/*
 * @Description: 神策埋点统一上报工具集
 */

import { snowplowTrack } from '@/common/snowplow';
import { stapeTrack } from '@/common/stape';

// 定义事件参数类型
type EventParams = Record<string, any>;

// 扩展 Window 接口
declare global {
  interface Window {
    vue_route?: {
      fullPath: string;
    };
  }
}

export const SDUtils = {
  /**
   * @desc 普通埋点上报
   * @param eventName 事件名称
   * @param params 事件参数
   * @param {boolean} [options.isSendFlag=true]
   *   true  → 同时上报神策 + sGTM（默认行为）
   *   false → 仅上报 sGTM，跳过神策（用于神策侧已下线的埋点，保留代码不删除）
   */
  sensorsTrack: (eventName: string, params: EventParams, { isSendFlag = true } = {}): void => {
    try {
      const _params: EventParams = {
        $url: window.vue_route
          ? `${window.location.origin}${window.vue_route?.fullPath}`
          : window.location.href,
      };
      // 根据标准：只要是值为 '', null, undefined, 'null', 'undefined'
      Object.keys(params).forEach((key: string) => {
        const v = params[key];
        if (
          v !== '' &&
          v !== 'null' &&
          v !== 'undefined' &&
          v !== null &&
          v !== undefined &&
          !(v instanceof Array && !v.length)
        ) {
          _params[key] = v;
        }
      });

      // 神策上报：isSendFlag = false 时跳过（埋点下线场景）
      if (isSendFlag) {
        window.sensors?.track(eventName, _params);
      }

      // sGTM 上报：始终执行，与 isSendFlag 无关
      stapeTrack(eventName, _params);

      // Snowplow 上报：旁路镜像过滤后的神策参数，内部自行判断开关和初始化状态
      snowplowTrack(eventName, _params);
    } catch (error) {
      console.log('sensors track error', error);
    }
  },

  /**
   * @desc 神策登录事件
   * @param uuid 用户唯一标识
   */
  login: (uuid: string | null | undefined): void => {
    try {
      if (uuid) {
        window.sensors?.login(uuid);
      } else {
        window.sensors?.logout();
      }
    } catch (error) {
      console.log('sensors login error', error);
    }
  },
  /**
   * 神策埋点，用户登出事件
   */
  logout: (): void => {
    try {
      window.sensors?.logout();
      window.sensors?.setProfile({ pub_is_login: false });
    } catch (error) {
      console.log('sensors logout error', error);
    }
  },
};
